module.exports = "/images/sign-form.png?e17e50c268c5a50b297328b53b4bf0ff";